import alt from 'framework/alt';

import EelMetrics from 'sdk/EelMetrics';
import MetricsActions from 'actions/MetricsActions';

class MetricsStore {
  constructor() {
    this.state = {
      failedEvents: [],
    };

    this.bindListeners({
      postFailed: MetricsActions.postFailed,
    });
  }

  // If messages fail for a 4xx, they won't succeed on a retry
  postFailed(data) {
    if (data && data.message === EelMetrics.postMetricsDisabledMessage) return;
    if (data && !(data.httpStatus >= 400 && data.httpStatus <= 499)) {
      data.failedEvents.forEach((failedEvent) => {
        this.state.failedEvents.push(failedEvent);
      });
    }
  }
}

export default alt.createStore(MetricsStore, 'MetricsStore');
